<template>
    <div class="MemberCard mx-auto my-2">
        <Nav></Nav>
        <img class="mx-auto my-2" style="width:100%;" src="../../assets/images/MemberCard.png" />
        <div class="d-flex">
            <svg class="barcode mx-auto mb-3"
                :jsbarcode-value="DeweyUserId"
                jsbarcode-format="auto"
                jsbarcode-textmargin="0"
                jsbarcode-fontoptions="bold"
                jsbarcode-height="60"
            ></svg>
        </div>
        <MemberButtons></MemberButtons>
    </div>
</template>

<script>
import Nav from '@/components/Nav'
import MemberButtons from '@/components/LineComponents/MemberButtons'
import {app} from '@/main'
import Vue from 'vue'
import axios from 'axios'
import jsbarcode from 'jsbarcode'
// import moment from 'moment'


export default {
    name: 'MemberCard',
    components:{
        Nav,MemberButtons
    },
    data () {
        return {
            Token:'',
            DeweyUserId:'',
        }
    },
    mounted(){
        JsBarcode(".barcode").init();
        
    },
    methods:{
    },
    created(){
        this.DeweyUserId = JSON.parse(sessionStorage.getItem('UserData')).deweyUserId;
    },
}
</script>




// WEBPACK FOOTER //
// src/components/line/MemberCard.vue